import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/orders/Wrapper.tsx");
